import { useCart } from "../context/CartContext";
import CartItemCard from "../components/CartItemCard";
import "../styles/Cart.css"
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import NavigationControl from "../components/NavigationControl";
import Loading from "../components/Loading";
import Error from "../components/Error";

const Cart = () => {
    const { cart, isLoading, error, mutationPending, mutationError } = useCart();
    const navigate = useNavigate();


    const checkOutHandler = (e) => {
        e.preventDefault();
        navigate("/checkout/address")
    }

    if (isLoading || mutationPending) return <Layout><Loading /></Layout>
    if (error) return <Error />
    if (cart.items.length === 0) {
        return (
            <Layout>
                <NavigationControl /><br />
                <p className="cart" style={{ textAlign: "center" }} >Cart is empty</p>
            </Layout>
        )
    };

    return (
        <Layout>
            <NavigationControl />
            <div className="cart">
                <div className="cartContainer">
                    <h2>Cart</h2>

                    {cart?.items.map((item, i) => (
                        <CartItemCard key={i} item={item} />
                    ))}

                    <div className="cartSummery">
                        <p className="total"><span>Items ({cart.items.length}): </span><b>₹{cart?.totalAmount}</b></p>
                        <p className="total"><span>Estimated total: </span> <b>₹{cart?.totalAmount}</b></p>
                        <p style={{ color: "var(--primary-color)", fontSize: "12px" }}>Taxes & shipping calculated at checkout</p>
                        <br />
                        <button className="btn" onClick={checkOutHandler}>Checkout</button>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Cart;
